import React, { useState } from 'react';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'premium'>('premium');
  const packs = {
    basic: {
      id: 'basic',
      icon: '📘',
      title: 'PACK CI 6×6',
      subtitle: '6 Tomos + 4 Bonos',
      ideal: 'Todas las etapas · 35m² → 95m²',
      oldPrice: '$41.100',
      price: '$19.990',
      url: 'https://checkout.zentralpro.store/cart/44025490112548:1',
      ctaText: '→ ACCEDER AHORA'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      badge: '⭐ MÁS VENDIDO',
      title: 'PACK CI 6×6 + GESTIÓN',
      subtitle: 'Todo el 6×6 + Acelerador + Director de Obra',
      ideal: 'Controlar contratos, tiempos y costos como un profesional',
      oldPrice: '$75.000',
      price: '$27.990',
      url: 'https://checkout.zentralpro.store/cart/44025493553188:1',
      ctaText: '→ ACCEDER AHORA — PACK + GESTIÓN'
    }
  };
  const selected = packs[selectedPack];
  return <div id="precios" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248">
      <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-beige-dark" data-id="element-249">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-charcoal uppercase tracking-wide" data-id="element-250">
          ELEGÍ TU <span className="italic text-gold" data-id="element-251">PACK CI 6×6</span>
        </h2>

        <div className="space-y-4 mb-8" data-id="element-252">
          {/* Basic Pack Card */}
          <div onClick={() => setSelectedPack('basic')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'basic' ? 'border-gold bg-gold/5' : 'border-beige-dark hover:border-gray-300 bg-transparent'}`} data-id="element-253">
            {/* Radio Button */}
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-gold' : 'border-gray-300'}`} data-id="element-254">
              {selectedPack === 'basic' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-255" />}
            </div>

            {/* Card Content */}
            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-256">
              <div className="flex-1" data-id="element-257">
                <div className="text-xl mb-2" data-id="element-258">{packs.basic.icon}</div>
                <h3 className="text-lg font-bold text-charcoal uppercase leading-tight" data-id="element-259">
                  {packs.basic.title}
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-260">
                  {packs.basic.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-261">
                  Ideal para: {packs.basic.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0" data-id="element-262">
                <div className="text-gray-400 line-through text-sm mb-1" data-id="element-263">
                  {packs.basic.oldPrice}
                </div>
                <div className="text-2xl md:text-3xl font-bold text-charcoal" data-id="element-264">
                  {packs.basic.price}{' '}
                  <span className="text-lg font-normal text-gray-500" data-id="element-265">ARS</span>
                </div>
              </div>
            </div>
          </div>

          {/* Premium Pack Card */}
          <div onClick={() => setSelectedPack('premium')} className={`relative rounded-2xl p-5 md:p-6 cursor-pointer transition-all border-2 flex items-center gap-4 md:gap-6 ${selectedPack === 'premium' ? 'border-gold bg-gold/5' : 'border-beige-dark hover:border-gray-300 bg-transparent'}`} data-id="element-266">
            {/* Radio Button */}
            <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 'premium' ? 'border-gold' : 'border-gray-300'}`} data-id="element-267">
              {selectedPack === 'premium' && <div className="w-3 h-3 rounded-full bg-gold" data-id="element-268" />}
            </div>

            {/* Card Content */}
            <div className="flex-grow flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-269">
              <div className="flex-1" data-id="element-270">
                <div className="text-xl mb-2 flex items-center gap-2" data-id="element-271">
                  {packs.premium.icon}
                  <span className="text-[10px] font-bold bg-gold/15 text-gold px-2 py-0.5 rounded-full uppercase tracking-wider border border-gold/30" data-id="element-272">
                    {packs.premium.badge}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-charcoal uppercase leading-tight" data-id="element-273">
                  {packs.premium.title}
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-274">
                  {packs.premium.subtitle}
                </p>
                <p className="text-sm text-gold mt-2 font-medium" data-id="element-275">
                  Ideal para: {packs.premium.ideal}
                </p>
              </div>
              <div className="text-left sm:text-right flex-shrink-0" data-id="element-276">
                <div className="text-gray-400 line-through text-sm mb-1" data-id="element-277">
                  {packs.premium.oldPrice}
                </div>
                <div className="text-2xl md:text-3xl font-bold text-charcoal" data-id="element-278">
                  {packs.premium.price}{' '}
                  <span className="text-lg font-normal text-gray-500" data-id="element-279">ARS</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dynamic CTA Button */}
        <a href={selected.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-gold hover:bg-gold-light text-white text-center font-bold py-4 md:py-5 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 text-lg" data-id="element-280">
          {selected.ctaText}
        </a>
      </div>
    </div>;
}